import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Figures from "../../form/Figures";
import parse_url from "locutus/php/url/parse_url";
import parse_str from "locutus/php/strings/parse_str";

class videoForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <TextInput name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-md-10">
                        <TextInput name="title" value={this.props.values.title} label="Megnevezés" saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("title")}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <TextInput name="youtube_id" value={this.props.values.youtube_id} label="Youtube" saveChanges={(field, value) => {
                            const pattern = /^((data|http|https|ftp):)/;
                            if (pattern.test(value) && value.indexOf("youtube") !== -1) {
                                value = parse_url(value);
                                let params = {};
                                parse_str(value.query, params);
                                value = params.v || '';
                            }
                            this.props.setFieldValue(field, value);
                        }} {...this.props.getFieldProps("youtube_id")} />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="figures" label="Képek" componentConfig={this.props.componentConfig} data={this.props.values} />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(videoForm);
